/**
 * --------------------------------------------------------------------------
 * Isvek (v1.0.0): utils.js
 * Licensed under MIT (https://isvek.ru/main/LICENSE.md)
 * --------------------------------------------------------------------------
 */

/**
 * Пространство имён для настроек
 * @type {string}
 * @constant
 */
export const NAMESPACE = 'strt'

/**
 * Глобальный объект настроек, инициализируется из window
 * @type {Object}
 * @private
 */
const settings = typeof window[NAMESPACE + 'Settings'] === 'object' ? window[NAMESPACE + 'Settings'] : {}

/**
 * Получить значение настройки по имени.
 * @param {string} name - Имя настройки.
 * @param {*} [fallback] - Значение по умолчанию, если настройка не найдена.
 * @returns {*} Значение настройки или fallback.
 */
export const getSetting = (name, fallback) => name in settings ? settings[name] : fallback

/**
 * Получить все текущие настройки.
 * @returns {Object} Все настройки.
 */
export const getSettings = () => settings

/**
 * Установить значение настройки по имени.
 * @param {string} name - Имя настройки.
 * @param {*} value - Значение настройки.
 * @returns {void}
 */
export const setSetting = (name, value) => {
  settings[name] = value

  if (typeof window !== 'undefined') {
    window[NAMESPACE] = window[NAMESPACE] || {}
    window[NAMESPACE + 'Settings'] = settings
  }
}

